import React, { useCallback, useState } from "react";
import help from "../Assets/help.svg";
import {
  Button,
  CircularProgress,
  FormHelperText,
  TextField,
} from "@mui/material";
import UserAssignField from "../../../../../components/UserAssign/UserAssignField";
import styles from "./VoxbayDetails.module.css";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { ValidateAgentId } from "../../service/integrations.request";
import AgentIdPopup from "./HelpPopup/AgentIdPopup";
import CallerIdPopup from "./HelpPopup/CallerIdPopup";
import DepartmentIdPopup from "./HelpPopup/DepartmentIdPopup";

function AddAgents(props: any) {
  const {
    employees,
    appsList,
    validatedAgent,
    instituteDetails,
    AddVoxbayAgent,
    addVoxbayLoading,
  } = props;
  const { validateAgentError, validateAgentSuccess, agentAddedLoading } =
    useSelector((state: any) => state.appIntegrations);

  const ozonetelApp = appsList?.find((app: any) => app.appCode === "OZONETEL");
  const ozonetelAppApiKey = ozonetelApp?.appConfigData?.apiKey;
  const ozonetelAppUserName = ozonetelApp?.appConfigData?.userName;

  const [agentsArray, setAgentsArray] = useState<any>([
    {
      userId: "",
      extensionId: "",
      extensionIdValid: false,
      extensionIdUnique: true,
      departmentId: "",
      departmentIdValid: false,
      departmentIdUnique: true,
      callerId: "",
      callerIdValid: false,
      callerIdUnique: true,
    },
  ]);
  const [emptyExtensionAgentField, setEmptyExtensionAgentField] =
    React.useState<boolean>(false);
  const [invalidExtensionAgentsError, setInvalidExtensionAgentsError] =
    React.useState<boolean>(false);
  const [emptyDepartmentAgentField, setEmptyDepartmentAgentField] =
    React.useState<boolean>(false);
  const [invalidDepartmentAgentsError, setInvalidDepartmentAgentsError] =
    React.useState<boolean>(false);
  // const [emptyAgentField, setEmptyAgentField] = React.useState<boolean>(false);
  // const [invalidAgentsError, setInvalidAgentsError] =
  //   React.useState<boolean>(false);
  const [emptyCallerAgentField, setEmptyCallerAgentField] =
    React.useState<boolean>(false);
  const [invalidCallerAgentsError, setInvalidCallerAgentsError] =
    React.useState<boolean>(false);

  const [showAgentIdPopup, setShowAgentIdPopup] = useState(false);
  const [showCallerIdPopup, setShowCallerIdPopup] = useState(false);
  const [showDepartmentIdPopup, setShowDepartmentIdPopup] = useState(false);

  const filteredEmployees = employees?.filter((employee: any) => {
    return !agentsArray?.some((agent: any) => agent.userId === employee.id);
  });

  const handleAddAgent = useCallback(() => {
    setAgentsArray([
      ...agentsArray,
      {
        userId: "",
        extensionId: "",
        extensionIdValid: false,
        extensionIdUnique: true,
        departmentId: "",
        departmentIdValid: false,
        departmentIdUnique: true,
        callerId: "",
        callerIdValid: false,
        callerIdUnique: true,
      },
    ]);
  }, [agentsArray]);

  // const handleAgentIdChange = useCallback(
  //   (value: string, index: number) => {
  //     // if (value) {
  //     //   let data = {
  //     //     agentId: value,
  //     //     instituteId: instituteDetails?.id,
  //     //     apiKey: ozonetelAppApiKey,
  //     //     userName: ozonetelAppUserName,
  //     //   };
  //     //   ValidateAgentId(data);
  //     // }

  //     const isExtensionIdUnique = agentsArray.every(
  //       (agent: any, i: number) => i === index || agent.extensionId !== value
  //     );
  //     const isDepartmentIdUnique = agentsArray.every(
  //       (agent: any, i: number) => i === index || agent.departmentId !== value
  //     );
  //     const isCallerIdUnique = agentsArray.every(
  //       (agent: any, i: number) => i === index || agent.callerId !== value
  //     );
  //     const updatedAgentsArray = [...agentsArray];
  //     // updatedAgentsArray[index].agentId = value;
  //     updatedAgentsArray[index] = {
  //       ...updatedAgentsArray[index],
  //       extensionId: value,
  //       extensionIdUnique: isExtensionIdUnique,
  //       extensionIdValid: false,
  //       departmentId: value,
  //       departmentIdUnique: isDepartmentIdUnique,
  //       departmentIdValid: false,
  //       callerId: value,
  //       callerIdUnique: isCallerIdUnique,
  //       callerIdValid: false,
  //     };
  //     setAgentsArray(updatedAgentsArray);
  //   },
  //   [agentsArray]
  // );

  const handleAgentIdChange = useCallback(
    (value: string, index: number, field: string) => {
      const updatedAgentsArray = [...agentsArray];

      // check duplicate for that specific field
      const isUnique = updatedAgentsArray.every(
        (agent: any, i: number) => i === index || agent[field] !== value
      );

      updatedAgentsArray[index] = {
        ...updatedAgentsArray[index],
        [field]: value, // <-- Update only this field
        [`${field}Unique`]: isUnique, // extensionIdUnique / departmentIdUnique / callerIdUnique
        [`${field}Valid`]: true, // reset validation for that field
      };

      setAgentsArray(updatedAgentsArray);
    },
    [agentsArray]
  );

  const handleAgentLeadAssignee = useCallback(
    (user: any, index: number) => {
      if (user) {
        // Update the agentsArray when a user is selected
        const updatedAgentsArray = [...agentsArray];
        updatedAgentsArray[index].userId = user.id;
        setAgentsArray(updatedAgentsArray);
      }
    },
    [agentsArray]
  );
  // filteredAgents;
  // filteredInvalidAgents;
  const filteredExtensionAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.extensonId?.trim() !== "" && item?.extensionIdValid === true
    );
  const filteredExtensionInvalidAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.extensionId?.trim() !== "" && item?.extensionIdValid === false
    );

  const filteredDepartmentAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.departmentId?.trim() !== "" && item?.departmentIdValid === true
    );
  const filteredDepartmentInvalidAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.departmentId?.trim() !== "" && item?.departmentIdValid === false
    );

  const filteredCallerAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.callerId?.trim() !== "" && item?.callerIdValid === true
    );
  const filteredCallerInvalidAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.callerId?.trim() !== "" && item?.callerIdValid === false
    );

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    const hasAgentIdUnique = agentsArray?.some(
      (item: any) => item.agentIdUnique === false
    );

    if (filteredExtensionAgents?.length === 0) {
      setEmptyExtensionAgentField(true);
      return; // Stop the submission if there's no agentId
    }
    if (filteredDepartmentAgents?.length === 0) {
      setEmptyDepartmentAgentField(true);
      return; // Stop the submission if there's no agentId
    }
    if (filteredCallerAgents?.length === 0) {
      setEmptyCallerAgentField(true);
      return; // Stop the submission if there's no agentId
    }
    if (filteredExtensionInvalidAgents?.length > 0) {
      setInvalidExtensionAgentsError(true);
      return;
    }
    if (filteredDepartmentInvalidAgents?.length > 0) {
      setInvalidDepartmentAgentsError(true);
      return;
    }
    if (filteredCallerInvalidAgents?.length > 0) {
      setInvalidCallerAgentsError(true);
      return;
    }

    try {
      const updatedAgentsArray = agentsArray?.map((item: any) => ({
        userId: item.userId,
        agentExtensionNumber: item?.extensionId,
        departmentId: item?.departmentId,
        callerDIDNumber: item?.callerId,
      }));
      emptyExtensionAgentField === false &&
        emptyCallerAgentField === false &&
        emptyDepartmentAgentField === false &&
        hasAgentIdUnique === false &&
        AddVoxbayAgent(updatedAgentsArray);
    } catch (error) {}
  };

  const handleAgentIdHelpClick = () => {
    setShowAgentIdPopup(true);
  };

  React.useEffect(() => {
    if (filteredExtensionInvalidAgents?.length === 0) {
      setInvalidExtensionAgentsError(false);
    }
  }, [filteredExtensionInvalidAgents]);

  React.useEffect(() => {
    if (filteredDepartmentInvalidAgents?.length === 0) {
      setInvalidDepartmentAgentsError(false);
    }
  }, [filteredDepartmentInvalidAgents]);

  React.useEffect(() => {
    if (filteredCallerInvalidAgents?.length === 0) {
      setInvalidCallerAgentsError(false);
    }
  }, [filteredCallerInvalidAgents]);

  React.useEffect(() => {
    if (filteredExtensionAgents?.length > 0) {
      setEmptyExtensionAgentField(false);
    }
  }, [filteredExtensionAgents]);

  React.useEffect(() => {
    if (filteredCallerAgents?.length > 0) {
      setEmptyCallerAgentField(false);
    }
  }, [filteredCallerAgents]);

  React.useEffect(() => {
    if (filteredDepartmentAgents?.length > 0) {
      setEmptyDepartmentAgentField(false);
    }
  }, [filteredDepartmentAgents]);

  React.useEffect(() => {
    if (employees) {
      const defaultAgentsArray = employees?.map((item: any) => ({
        userId: item.id,
        userName: item.firstName + " " + item.lastName,
        agentIdUnique: true,
        extensionId: "",
        extensionIdValid: false,
        extensionIdUnique: true,
        departmentId: "",
        departmentIdValid: false,
        departmentIdUnique: true,
        callerId: "",
        callerIdValid: false,
        callerIdUnique: true,
      }));
      setAgentsArray(defaultAgentsArray);
    }
  }, [employees]);

  const hasAtLeastOneValidAgent = (agents: any[]) => {
    return agents.some(
      (agent) =>
        agent.extensionId !== "" &&
        agent.departmentId !== "" &&
        agent.callerId !== "" &&
        agent.callerId?.length === 12
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <div className={styles.addAgentsSubHead}>
        Map nurture users to their corresponding Voxbay Agent IDs. This will
        enable the Voxbay widget on their nurture account.
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            flexBasis: "100%",
            color: "#667085",
            fontSize: "13px",
            fontWeight: "400",
            textAlign: "left",
          }}
        >
          Users
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#667085",
            fontSize: "13px",
            fontWeight: "400",
            lineHeight: "22px",
            textTransform: "capitalize",
            marginBottom: "2px",
            flexBasis: "100%",
            textAlign: "left",
          }}
        >
          Extension ID <span style={{ color: "#EC3939" }}>*</span>
          <div onClick={handleAgentIdHelpClick}>
            <img src={help} alt="help" style={{ cursor: "pointer" }} />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#667085",
            fontSize: "13px",
            fontWeight: "400",
            lineHeight: "22px",
            textTransform: "capitalize",
            marginBottom: "2px",
            flexBasis: "100%",
            textAlign: "left",
          }}
        >
          Department ID <span style={{ color: "#EC3939" }}>*</span>
          <div onClick={() => setShowDepartmentIdPopup(true)}>
            <img src={help} alt="help" style={{ cursor: "pointer" }} />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#667085",
            fontSize: "13px",
            fontWeight: "400",
            lineHeight: "22px",
            textTransform: "capitalize",
            marginBottom: "2px",
            flexBasis: "100%",
            textAlign: "left",
          }}
        >
          Caller ID <span style={{ color: "#EC3939" }}>*</span>
          <div onClick={() => setShowCallerIdPopup(true)}>
            <img src={help} alt="help" style={{ cursor: "pointer" }} />
          </div>
        </div>
      </div>

      {showAgentIdPopup && (
        <AgentIdPopup
          isOpen={showAgentIdPopup}
          onClose={() => setShowAgentIdPopup(false)}
        />
      )}
      {showDepartmentIdPopup && (
        <DepartmentIdPopup
          isOpen={showDepartmentIdPopup}
          onClose={() => setShowDepartmentIdPopup(false)}
        />
      )}
      {showCallerIdPopup && (
        <CallerIdPopup
          isOpen={showCallerIdPopup}
          onClose={() => setShowCallerIdPopup(false)}
        />
      )}
      <div
        style={{ maxHeight: "211PX", overflowY: "auto", paddingRight: "4px" }}
      >
        {agentsArray?.map((item: any, index: number) => (
          <div key={index} className={styles.addAgentsFieldWrap}>
            <div className={styles.addAgentsFieldItem}>
              <div className={styles.addAgentsFieldItemUserWrap}>
                <div className={styles.addAgentsFieldItemUserWrapAvatar}>
                  {item?.userName?.charAt(0)}
                </div>
                <div className={styles.addAgentsFieldItemUserName}>
                  {item?.userName}
                </div>
              </div>
            </div>
            <div className={styles.addAgentsFieldItem}>
              <TextField
                placeholder="Enter Extension ID"
                fullWidth
                inputProps={{
                  maxLength: 3, // <-- limit characters
                  inputMode: "numeric", // mobile numeric keyboard
                  pattern: "[0-9]*",
                  style: {
                    padding: "9.4px 12px",
                  },
                }}
                value={item?.extensionIdId}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                  handleAgentIdChange(onlyNumbers, index, "extensionId");
                }}
              />
              {!item?.extensionIdValid &&
                item?.extensionId !== "" &&
                item?.extensionIdUnique && (
                  <FormHelperText error>Invalid extension id.</FormHelperText>
                )}
              {item?.extensionIdValid &&
                item?.extensionId !== "" &&
                item?.extensionIdUnique && (
                  <FormHelperText sx={{ color: "#11c89b" }}>
                    Valid extension id.
                  </FormHelperText>
                )}
              {!item?.extensionIdUnique && (
                <FormHelperText error>
                  Extension ID should be unique.
                </FormHelperText>
              )}
            </div>
            <div className={styles.addAgentsFieldItem}>
              <TextField
                placeholder="Enter Department ID"
                fullWidth
                inputProps={{
                  maxLength: 3, // <-- limit characters
                  inputMode: "numeric", // mobile numeric keyboard
                  pattern: "[0-9]*",
                  style: {
                    padding: "9.4px 12px",
                  },
                }}
                value={item?.departmentId}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                  handleAgentIdChange(onlyNumbers, index, "departmentId");
                }}
              />
              {!item?.departmentIdValid &&
                item?.departmentId !== "" &&
                item?.departmentIdUnique && (
                  <FormHelperText error>Invalid department id.</FormHelperText>
                )}
              {item?.departmentIdValid &&
                item?.departmentId !== "" &&
                item?.departmentIdUnique && (
                  <FormHelperText sx={{ color: "#11c89b" }}>
                    Valid department id.
                  </FormHelperText>
                )}
              {!item?.departmentIdUnique && (
                <FormHelperText error>
                  Department ID should be unique.
                </FormHelperText>
              )}
            </div>
            <div className={styles.addAgentsFieldItem}>
              <TextField
                placeholder="Enter Caller ID"
                fullWidth
                inputProps={{
                  maxLength: 12, // <-- limit characters
                  inputMode: "numeric", // mobile numeric keyboard
                  pattern: "[0-9]*",
                  style: {
                    padding: "9.4px 12px",
                  },
                }}
                value={item?.callerId}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                  handleAgentIdChange(onlyNumbers, index, "callerId");
                }}
              />
              {!item?.callerIdValid &&
                item?.callerId !== "" &&
                item?.callerId?.length < 12 &&
                item?.callerIdUnique && (
                  <FormHelperText error>Invalid caller id.</FormHelperText>
                )}
              {item?.callerIdValid &&
                item?.callerId !== "" &&
                item?.callerId?.length === 12 &&
                item?.callerIdUnique && (
                  <FormHelperText sx={{ color: "#11c89b" }}>
                    Valid caller id.
                  </FormHelperText>
                )}
              {!item?.callerIdUnique && (
                <FormHelperText error>
                  Caller ID should be unique.
                </FormHelperText>
              )}
            </div>
          </div>
        ))}
      </div>

      <div>
        {(emptyExtensionAgentField ||
          emptyDepartmentAgentField ||
          emptyCallerAgentField) && (
          <FormHelperText error>
            Please fill atleast one valid agent id.
          </FormHelperText>
        )}
        {!(
          emptyExtensionAgentField ||
          emptyDepartmentAgentField ||
          emptyCallerAgentField
        ) &&
          invalidExtensionAgentsError &&
          invalidDepartmentAgentsError &&
          invalidCallerAgentsError && (
            <FormHelperText error>
              Please fill valid agent id or clear invalid agent ids.
            </FormHelperText>
          )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <Button
          color="primary"
          variant="contained"
          sx={{
            textTransform: "capitalize",
            maxWidth: "100%",
            mainWidth: "100%",
            "&.Mui-disabled": {
              backgroundColor: "rgb(241, 245, 248) ",
              color: "rgba(138, 148, 166, 1)",
            },
          }}
          fullWidth
          onClick={handleSubmit}
          disabled={!hasAtLeastOneValidAgent(agentsArray) || addVoxbayLoading}
        >
          {addVoxbayLoading ? (
            <CircularProgress size={20} color={"inherit"} />
          ) : (
            "Continue"
          )}
        </Button>
      </div>
    </div>
  );
}

export default AddAgents;
